type GtagCommand = 'config' | 'event' | 'js';

declare global {
    interface Window {
        dataLayer?: unknown[];
        gtag?: (command: GtagCommand, target: string | Date, parameters?: object) => void;
    }
}

const measurementId = import.meta.env.VITE_GTAG_ID?.trim();
let initialized = false;

function hasMeasurementId(value: string | undefined): value is string {
    return value !== undefined && value.length > 0;
}

export function initializeAnalytics(): void {
    if (!hasMeasurementId(measurementId) || initialized) return;

    initialized = true;
    window.dataLayer = window.dataLayer ?? [];
    const gtag: NonNullable<Window['gtag']> = (...args) => {
        window.dataLayer?.push(args);
    };
    window.gtag = gtag;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    document.head.append(script);

    gtag('js', new Date());
    gtag('config', measurementId, { anonymize_ip: true, send_page_view: true });
}

export function trackEvent(
    name: string,
    parameters: Record<string, string | number | boolean>
): void {
    const gtag = window.gtag;
    if (!hasMeasurementId(measurementId) || gtag === undefined) return;
    gtag('event', name, parameters);
}
